import { SmsUsaRegistrationStatus } from '@mews-commander/data-access';
import { ArticlePath, createGuideLink, TextKey } from '@mews-commander/enums';
import { TextWithLinks } from '@mews-commander/ui';
import { useLocalizeText } from '@mews/framework';
import { Banner } from '@optimus-web/core';

interface RegistrationErrorProps {
    registrationStatus: SmsUsaRegistrationStatus;
}

export const RegistrationError = ({ registrationStatus }: RegistrationErrorProps) => {
    const localizeText = useLocalizeText();

    const faqLink = {
        id: 'smsPackageFaq',
        url: createGuideLink(ArticlePath.SMSPackageFaq),
        text: localizeText({ textKey: TextKey.SmsPackageFaq }),
    };

    switch (registrationStatus) {
        case SmsUsaRegistrationStatus.BrandRegistrationFailed:
        case SmsUsaRegistrationStatus.BrandRegistrationSuspended: {
            return (
                <Banner
                    primaryText={
                        <TextWithLinks
                            links={[faqLink]}
                            text={localizeText({ textKey: TextKey.SmsBrandRegistrationFailedMessage })}
                        />
                    }
                    variant="error"
                />
            );
        }
        case SmsUsaRegistrationStatus.CampaignRegistrationFailed:
        case SmsUsaRegistrationStatus.CampaignRegistrationSuspended: {
            return (
                <Banner
                    primaryText={
                        <TextWithLinks
                            links={[faqLink]}
                            text={localizeText({ textKey: TextKey.SmsCampaignRegistrationFailedMessage })}
                        />
                    }
                    variant="error"
                />
            );
        }
        default:
            return null;
    }
};
